import React from 'react';

interface WristsStraightProps {}

export function WristsStraight(props: Readonly<WristsStraightProps>) {
	return (
		<svg width={138} height={60} viewBox="0 0 138 60" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_2182_17104)">
				<path
					fill="#999"
					d="M83.74 29.435c.417.363 8.656 6.992 8.646 9.88-1.05 3.087-4.084 3.06-4.921 3.24-2.517.538-9.372-4.924-13.17-4.786 0 0-2.33.153-5.174.256-2.844.103-5.375.09-5.375.09-3.91.566-12.627 2.68-12.627 2.68-2.877.654-3.863.703-5.123.578-3.176-.313-7.408-1.976-7.983-2.376 0 0-1.497-.87-2.401-2.612 0 0-.83-2.709-.822-4.634.006-1.925 1.897-4.174 1.897-4.174.85-.834 5.16-3.882 6.893-4.935 1.733-1.053 6.23-2.284 6.467-2.25 0 0 2.613-.715 6.532-1.43 2.286-.126 5.29-1.903 5.29-1.903 1.74-.962 3.087-.921 3.087-.921 2.46-.119 3.885.816 5.368 2.632 1.508 1.642 5.563 3.229 7.235 4.795 1.67 1.566 5.765 5.508 6.182 5.87z"
				/>
				<path
					fill="#999"
					d="M45.742 24.817c1.248 1.863 1.642 3.684 1.506 5.992-.137 2.308-.848 4.902-2.233 6.316-.96.98-2.8 2.172-4.432 2.907-3.648 1.643-9.892 1.944-12.327 1.756-29.002-2.234-26.896-2.814-36.981-3.87-16.81-1.758-35.885-4.411-38.285-5.352-2.4-.942-6.36-3.625-7.661-5.043-1.302-1.418-4.505-5.347-4.555-8.84-.05-3.492.82-6.231 2.471-9.295 1.65-3.064 4.37-4.659 6.42-5.292 2.46-.76 6.515-.585 9.58-.27 9.721 1.14 19.167 3.52 28.752 6.651C-4.4 13.063-1.263 15.4 6.44 17.94a81.158 81.158 0 0026.6 3.481c2.116-.196 5.051.055 6.482.201 1.432.146 5.038 1.43 6.22 3.196z"
				/>
				<path d="M-45.773 58.508H146" stroke="#BEC4CB" strokeWidth={2} strokeLinecap="round" />
				<path
					stroke="#71828F"
					strokeWidth={2}
					strokeLinecap="round"
					d="M85.707 48.145l-5.859.354M72.496 48.84l-5.859.354M59.285 49.676l-5.858.354M112.129 46.61l-5.859.354M98.918 47.445l-5.859.355"
				/>
				<path
					fill="#445662"
					d="M38.733 53.894c0-3.126 2.943-3.25 2.943-3.25l78.966-4.59c3.403 0 6.167 2.494 6.167 5.575 0 3.077-2.764 5.57-6.167 5.57H42.387s-3.654-.179-3.654-3.305z"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2182_17104">
					<path fill="#fff" d="M0 0H138V60H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}
